import { FilesGetterTypes } from './types';

export const getters = {
    [FilesGetterTypes.GetFiles](state) {
        return state.files
    },
}